// Code review - In Progress
// Documentation - In Progress
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import DropDown from "../ReusableComponents/DropDown";
import InputText from "../ReusableComponents/InputText";
import download from "../image/download.png";
import { useNavigate } from "react-router-dom";
import { IUDAPI, ImageAPI } from "../services/APIConnection";

const UserProfile = ({ data, closePopup }) => {
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [sdp, setSdp] = useState([]);
  const [location, setLocation] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState(1);
  const [userId, setUserId] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [showImage, setShowImage] = useState("");
  const [imageUploaded, setimageUploaded] = useState("");
  const [designation, setDesignation] = useState("");
  const [language, setLanguage] = useState("");
  const [roleGroub, setRoleGroup] = useState("");
  const [mstUserId, setMstUserId] = useState("");
  const [bindCountryDD, setBindCountryDD] = useState([
    { value: "1", label: "India" },
    { value: "2", label: "America" },
    { value: "3", label: "Korea" },
  ]);

  const [newImageUploaded, setNewImageUploaded] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setMstUserId(data[0].MstUserId);
      setFirstName(data[0].FirstName_en);
      setMiddleName(data[0].MiddleName_en);
      setLastName(data[0].LastName_en);
      setEmail(data[0].UserEmail);
      setPhone(data[0].UserMobile);
      setUserId(data[0].UserId);
      setShowImage(data[0].UserProfileImg);

      setimageUploaded(data[0].UserProfileImg);
      setLanguage(data[0].Language);
      setDesignation(data[0].Designation);
      setRoleGroup(data[0].RoleName);
      setState(data[0].StateName_en);
      setLocation(data[0].LocationName_en);
    } else {
    }

    if (Object.values(data)) {
      let userSDPs = Object.values(data);

      // Filter out undefined, null, and empty string values
      let sdpData = userSDPs
        .map((items) => items.SDP_en)
        .filter((sdp) => sdp !== undefined && sdp !== null && sdp !== "");

      setSdp(sdpData);
    }
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    var createdBy = sessionStorage.getItem("createdBy");
    if (createdBy == null || createdBy == "") {
      navigate("/");
    }
  }, [navigate, data]);

  // const handleImageUpload = async () => {
  //   if (!imageUploaded) {
  //     return;
  //   } else {
  //     const formData = new FormData();
  //     formData.append("UserImage", imageUploaded);
  //     const response = await ImageAPI(formData, "UserAPI/UserImageUpload");
  //     setShowImage(response.data);

  //     setNewImageUploaded(true);
  //   }
  // };

  const createdBy = sessionStorage.getItem("createdBy");

  const handleImageUpload = async () => {
    if (!imageUploaded) {
      return;
    }

    const formData = new FormData();
    formData.append("UserImage", imageUploaded);

    try {
      const response = await ImageAPI(
        formData,
        "UserAPI/UserImageUpload"
      );

      setShowImage(response.data);
      setNewImageUploaded(true);

      // ✅ Success Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "UserAPI/UserImageUpload",
          action: "FILE UPLOAD",
          status: "SUCCESS",
          tableName: null,
          description: `User image uploaded successfully - ${imageUploaded?.name || ""
            }`,
        },
        "Log/IUDLog"
      );
    } catch (error) {
      console.error("Error uploading image:", error);

      // ❌ Failed Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "UserAPI/UserImageUpload",
          action: "FILE UPLOAD",
          status: "FAILED",
          tableName: null,
          description: `User image upload failed - ${error?.message || "Unknown Error"
            }`,
        },
        "Log/IUDLog"
      );
    }
  };

  const handleSubmit = async (items, flag) => {
    setDisabledBtn(true);
    if (flag == 2) {
      const userPayload = {
        mstUserId: mstUserId,
        userProfileImg: showImage,
        createdBy: mstUserId,
        flag: flag,
      };

      const response = await IUDAPI(
        userPayload,
        "UserAPI/UpdateUserProfileImage"
      );
      if (response.data.Table[0].Result === "M") {
        data[0].UserProfileImg = showImage;
        setTimeout(() => {
          closePopup(true);
        }, 1000);
        setNewImageUploaded(false);
        setDisabledBtn(false);
      }
    }
  };

  return (
    <div className="w-full">
      <div className="text-xl mx-5 font-medium text-neutral-700 ">
        {"User Profile"}
      </div>
      <div className=" flex flex-col w-full">
        <div className={""}>
          <div className={mainTable.mainContentScreen}>
            <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit ">
              <div className="grid gap-4 mb-6 md:grid-cols-3">
                <InputText
                  inputType="text"
                  title="First Name"
                  name="firstName"
                  placeholder="Vaibhav"
                  content={firstName}
                  controlFunc={(e) => setFirstName(e.target.value)}
                  disabled={true}
                />
                <InputText
                  inputType="text"
                  title="Middle Name"
                  name="middleName"
                  placeholder="Middle Name"
                  content={middleName}
                  controlFunc={(e) => setMiddleName(e.target.value)}
                  disabled={true}
                />
                <InputText
                  inputType="text"
                  title="Last Name"
                  name="lastName"
                  placeholder="S"
                  content={lastName}
                  controlFunc={(e) => setLastName(e.target.value)}
                  disabled={true}
                />
                <InputText
                  inputType="email"
                  title="Email"
                  name="email"
                  placeholder="vaibhav@fpaindia.org"
                  content={email}
                  controlFunc={(e) => setEmail(e.target.value)}
                  disabled={true}
                />
                <InputText
                  inputType="text"
                  title="Mobile Number"
                  name="phone"
                  placeholder="XXXXX XXXXX"
                  content={phone}
                  controlFunc={(e) => setPhone(e.target.value)}
                  disabled={true}
                />

                <InputText
                  inputType="text"
                  title="Language"
                  name="language"
                  content={language}
                  controlFunc={(e) => setLanguage(e.target.value)}
                  disabled={true}
                />

                <InputText
                  inputType="text"
                  title="Designation"
                  name="userId"
                  content={designation}
                  controlFunc={(e) => setDesignation(e.target.value)}
                  disabled={true}
                />
                <InputText
                  inputType="text"
                  title="Role/Groups"
                  name="userId"
                  content={roleGroub}
                  controlFunc={(e) => setRoleGroup(e.target.value)}
                  disabled={true}
                />
                <DropDown
                  classDiv="hidden"
                  title="Country"
                  options={bindCountryDD}
                  placeholder="Select"
                  name="country"
                  selectedOption={country}
                  controlFunc={(e) => setCountry(e.target.value)}
                  disabled={true}
                />
                {state && (
                  <InputText
                    inputType="text"
                    title="State"
                    name="userId"
                    content={state}
                    controlFunc={(e) => setState(e.target.value)}
                    disabled={true}
                  />
                )}
                {location && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    name="userId"
                    content={location}
                    controlFunc={(e) => setLocation(e.target.value)}
                    disabled={true}
                  />
                )}
                {sdp.length > 0 && (
                  <InputText
                    inputType="text"
                    title="S.D.P."
                    name="sdp"
                    content={sdp}
                    disabled={true}
                  />
                )}
                <InputText
                  inputType="file"
                  title="Photo"
                  name="image"
                  handleImageUpload={(e) => setimageUploaded(e.target.files[0])}
                  limitMassage={
                    "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
                  }
                />
                <div className={mainTable.grid2}>
                  <div className="mt-7 mr-7">
                    <button
                      type="button"
                      className={mainTable.submitButton}
                      onClick={() => handleImageUpload()}
                    >
                      UPLOAD
                    </button>
                  </div>
                  <div>
                    <img
                      src={showImage ? showImage : download}
                      alt="Image"
                      className="rounded-full w-20 h-20"
                    />
                  </div>
                </div>{" "}
              </div>
            </form>
            {newImageUploaded && (
              <div className={mainTable.submitCancelMainDiv}>
                <button
                  data-modal-hide="bottom-right-modal"
                  type="button"
                  className={
                    disabledBtn
                      ? mainTable.disabledSubmitButton
                      : mainTable.submitButton
                  }
                  onClick={() => handleSubmit(0, 2)}
                  disabled={disabledBtn}
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
